<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.js';
import {
    projectState
} from '@app/store/projectStore.js';
import {
    historyState
} from '@app/store/historyStore.js';
import {
    editorState
} from "@app/store/editorStore.js";
import shiftLineForward from "@app/external/cc-lib/dist/functions/quill/shiftLineForward.js";
import getAvgTimePerWord from "@app/external/cc-lib/dist/functions/events/getAvgTimePerWord.js";

function shiftLineToNextEvent() {
    try {
        if (!$eventGroupState[$projectState.selected]) return;
        if ($eventGroupState[$projectState.selected].selected.length === 0) return;
        if ($eventGroupState[$projectState.selected].selected[0] === $eventGroupState[$projectState.selected].events.length -1) return;

        $eventGroupState[$projectState.selected].selected = [$eventGroupState[$projectState.selected].selected[0]];

        let res = shiftLineForward($eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]], $eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]+1]);

        $eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]].text = res.event1.text;

        $eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]+1].text = res.event2.text;

        if (window.quillEditor){
            quillEditor.clipboard.dangerouslyPasteHTML(
                $eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]].text
            );
        }

        if ($editorState.updateTimeOnEdit){
            let currentEvent = $eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]];
            let nextEvent = $eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]+1];

            if (currentEvent.start && currentEvent.end && nextEvent.start && nextEvent.end){
                let avgTimePerWord = getAvgTimePerWord(currentEvent);
                let numberOfWordsInLastLineOfLastEvent = quillEditor.getText(0).split("\n").pop().split(" ").length;
                if (avgTimePerWord > 0){
                    $eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]+1].start -= avgTimePerWord*numberOfWordsInLastLineOfLastEvent;
                    $eventGroupState[$projectState.selected].events[$eventGroupState[$projectState.selected].selected[0]].end -= avgTimePerWord*numberOfWordsInLastLineOfLastEvent;
                }                                
            }
        }

        historyState.insert({
            name: "shift line", //action name
            eventGroup: $projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify($eventGroupState)
            }]
        });
    } catch (err) {
        console.log(err, err.message);
    }
}
</script>
<li class="nav-item" 
    role="none">
    <a class="nav-link"
       href="#!/"
       role="button"
       id="shift-line-forward-btn"
       aria-label="Shift Line Down"
       class:disabled={!$eventGroupState[$projectState.selected] || $eventGroupState[$projectState.selected].selected.length === 0 || $eventGroupState[$projectState.selected].selected[0] === $eventGroupState[$projectState.selected].events.length-1}
       aria-disabled={!$eventGroupState[$projectState.selected] || $eventGroupState[$projectState.selected].selected.length === 0 || $eventGroupState[$projectState.selected].selected[0] === $eventGroupState[$projectState.selected].events.length-1}
       on:click={shiftLineToNextEvent}>
        <i class="bi bi-arrow-bar-down" aria-hidden="true"></i>
        <sub aria-hidden="true"><i class="bi bi-fonts"></i></sub>
    </a>
</li>